import React from "react";
import { Box } from "@mui/system";
import { ReactComponent as OOHLogo } from "../../../../../assets/icons/logo-black.svg";
import { ReactComponent as Group2 } from "../../../../../assets/icons/Group2.svg";
import { ReactComponent as CheckedGo } from "../../../../../assets/icons/CheckedGoNew.svg";
import { ReactComponent as BitLogo } from "../../../../../assets/icons/BitLogo.svg";
import { ReactComponent as BovagGurantie } from "../../../../../assets/icons/Bovag_logo.svg";
import { ReactComponent as Combained } from "../../../../../assets/icons/CombainedLogo.svg";

export const getLogoIcon = (certificateName, index, count = "") => {
  switch (certificateName) {
    case "Status_100OH": {
      return (
        <Box key={index}>
          <OOHLogo />
          {count}
        </Box>
      );
    }

    case "Status_Label3": {
      return (
        <Box key={index}>
          <BitLogo />
          {count}
        </Box>
      );
    }

    case "Status_Label4": {
      return (
        <Box key={index}>
          <BovagGurantie />

          {count}
        </Box>
      );
    }
    case "Status_Checked_Go": {
      return (
        <Box key={index}>
          <CheckedGo />
          {count}
        </Box>
      );
    }
    case "Combined_Certificate":
      return (
        <Box key={index}>
          <Combained />
          {count}
        </Box>
      );

    case "Status_Label5":
    default: {
      return (
        <Box key={index}>
          <Group2 />
          {count}
        </Box>
      );
    }
    
  }
};
